import { buildQaLabel } from "./functions";

export const PICKS_DATA_SOURCE = {
  GSA: "GSA",
  USGSA: "USGSA",
  SRW: "SRW",
  RAS: "RAS",
  EQB: "EQB"
};

export const pickIcon = {
  [PICKS_DATA_SOURCE.GSA]: "timeForm",
  [PICKS_DATA_SOURCE.SRW]: "badge",
  [PICKS_DATA_SOURCE.EQB]: "trackMaster",
  [PICKS_DATA_SOURCE.USGSA]: "trackMaster",
  [PICKS_DATA_SOURCE.RAS]: "rs",
  default: "result"
};

const BASE_LABEL = "inline-analysis";
const CONTAINER_LABEL = "container";
const PARAGRAPH_LABEL = "paragraph";
const ICON_LABEL = "icon";

export const QA_LABELS = {
  CONTAINER: buildQaLabel([BASE_LABEL, CONTAINER_LABEL]),
  PARAGRAPH_CONTAINER: buildQaLabel([
    BASE_LABEL,
    PARAGRAPH_LABEL,
    CONTAINER_LABEL
  ]),
  PARAGRAPH: buildQaLabel([BASE_LABEL, PARAGRAPH_LABEL]),
  ICON: buildQaLabel([BASE_LABEL, ICON_LABEL])
};
